var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "759px",
    height: "756px",
    viewBox: "0 0 759 756",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mass-return") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-Icons",
    transform: "translate(-3110.000000, -49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mass-return",
    transform: "translate(3110.606240, 49.232991)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C7DADE",
    cx: 301.39376,
    cy: 294.767009,
    r: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Reply-all_line_74",
    transform: "translate(158.393760, 199.767009)",
    stroke: "#000000",
    strokeWidth: 22.2222222
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "195.555556 4.44833389 0 200.175025 195.555556 395.901717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.805556,321.948166 L500,413 L500,289.141703 C500,203.094244 430.416667,133.450017 344.444444,133.450017 L277.777778,133.450017 L277.777778,0 L77.7777778,200.175025 L277.777778,400.35005 L277.777778,266.900034 L350.972222,266.900034 C390.416667,266.900034 426.944444,287.890609 446.805556,321.948166 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.dc4ded2785bd43978a263b42b98294f8.svg";
export { ForwardRef as ReactComponent };